import moment from "moment";
import * as React from "react";

import {
  VideoProjectQaBadges,
  VideoProjectRevisionBadge,
  VideoProjectStatusColumnId,
  VideoProjectStatusPicker,
} from "@/components/VideoProjectStatusPicker";
import { VideoProject } from "@/services/bedrock";

interface VideoProjectStatusStripProps {
  videoProject: VideoProject;
  currentUserId?: number;
  disabled?: boolean;
  onStatusColumnSelect: (columnId: VideoProjectStatusColumnId) => void;
  onQaFailedClick?: () => void;
}

function formatStatusDate(statusDate?: string | null) {
  if (!statusDate) return null;
  const date = moment(statusDate);
  if (!date.isValid()) return null;
  return date.format("MMM D, YYYY [at] h:mm a");
}

export function VideoProjectStatusStrip({
  videoProject,
  currentUserId,
  disabled = false,
  onStatusColumnSelect,
  onQaFailedClick,
}: VideoProjectStatusStripProps) {
  const qaFailed = videoProject.qaStatus === "REJECTED";
  const statusDateLabel = formatStatusDate(videoProject.statusDate);
  const hasQaBadges = (videoProject.revisionCount ?? 0) > 0 || (videoProject.qaFailureCount ?? 0) > 0;

  return (
    <>
      <div className="flex flex-col gap-1.5">
        <div className="flex flex-row justify-between items-center gap-2">
          <span className="font-medium text-slate-500">Status:</span>
          <VideoProjectStatusPicker
            status={videoProject.status}
            statusDate={videoProject.statusDate}
            archived={!!videoProject.archived}
            requiresQa={videoProject.requiresQa}
            currentUserId={currentUserId}
            labeled
            menuItemLabels="event"
            disabled={disabled}
            onSelect={onStatusColumnSelect}
          />
        </div>
        {hasQaBadges ? (
          <div className="flex justify-end gap-1.5">
            <VideoProjectRevisionBadge revisionCount={videoProject.revisionCount} />
            <VideoProjectQaBadges
              qaFailed={qaFailed}
              qaFailureCount={videoProject.qaFailureCount}
              showFailedLabel
              onQaFailedClick={onQaFailedClick}
            />
          </div>
        ) : null}
      </div>
      {statusDateLabel ? (
        <div className="flex flex-row justify-between items-center flex-wrap gap-2">
          <span className="font-medium text-slate-500">Status Date:</span>
          <span className="text-slate-400 text-xs font-medium">{statusDateLabel}</span>
        </div>
      ) : null}
    </>
  );
}
